var map = {
	"./back_items-sprite-1x.png": "06c7",
	"./carpets-sprite-1x.png": "86d6",
	"./chairs-sprite-1x.png": "f5f1",
	"./deco-sprite-1x.png": "6b4e",
	"./lamps-sprite-1x.png": "471b",
	"./wall_items-sprite-1x.png": "bd8e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3cc0";